// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin0CountrySelectController from "./admin0_country_select_controller"
application.register("admin0-country-select", Admin0CountrySelectController)

import AdminMapController from "./admin_map_controller"
application.register("admin-map", AdminMapController)

import ActivityFormController from "./activity_form_controller"
application.register("activity-form", ActivityFormController)

import BreadcrumbsController from "./breadcrumbs_controller"
application.register("breadcrumbs", BreadcrumbsController)

import CharCountController from "./char_count_controller"
application.register("char-count", CharCountController)

import ButtonToTopController from "./button_to_top_controller"
application.register("button-to-top", ButtonToTopController)

import CollaborationFormController from "./collaboration_form_controller"
application.register("collaboration-form", CollaborationFormController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ExperienceSectorsController from "./experience_sectors_controller"
application.register("experience-sectors", ExperienceSectorsController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FlashesController from "./flashes_controller"
application.register("flashes", FlashesController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HierarchyTreeController from "./hierarchy_tree_controller"
application.register("hierarchy-tree", HierarchyTreeController)

import HomeNavigationController from "./home_navigation_controller"
application.register("home-navigation", HomeNavigationController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import MatomoController from "./matomo_controller"
application.register("matomo", MatomoController)

import OperationalAreasMapController from "./operational_areas_map_controller"
application.register("operational-areas-map", OperationalAreasMapController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import SplitFlapController from "./split_flap_controller"
application.register("split-flap", SplitFlapController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SwalController from "./swal_controller"
application.register("swal", SwalController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TranslationFieldsController from "./translation_fields_controller"
application.register("translation-fields", TranslationFieldsController)

import UploadsController from "./uploads_controller"
application.register("uploads", UploadsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CounterAnimationController from "./counter_animation_controller"
application.register("counter-animation", CounterAnimationController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import CurtainRevealController from "./curtain_reveal_controller"
application.register("curtain-reveal", CurtainRevealController)

import GeojsonDropController from "./geojson_drop_controller"
application.register("geojson-drop", GeojsonDropController)

import PortfolioScrollRevealController from "./portfolio_scroll_reveal_controller"
application.register("portfolio-scroll-reveal", PortfolioScrollRevealController)

import PortfolioCounterController from "./portfolio_counter_controller"
application.register("portfolio-counter", PortfolioCounterController)

import PortfolioNavController from "./portfolio_nav_controller"
application.register("portfolio-nav", PortfolioNavController)

import PortfolioLangController from "./portfolio_lang_controller"
application.register("portfolio-lang", PortfolioLangController)

import PortfolioStatsController from "./portfolio_stats_controller"
application.register("portfolio-stats", PortfolioStatsController)

import PortfolioContactController from "./portfolio_contact_controller"
application.register("portfolio-contact", PortfolioContactController)

import HomepageContactController from "./homepage_contact_controller"
application.register("homepage-contact", HomepageContactController)

import FormationsAccordionController from "./formations_accordion_controller"
application.register("formations-accordion", FormationsAccordionController)

import PhotoRepositionController from "./photo_reposition_controller"
application.register("photo-reposition", PhotoRepositionController)

import FormationBodyPreviewController from "./formation_body_preview_controller"
application.register("formation-body-preview", FormationBodyPreviewController)
